import { Backdrop, CircularProgress } from '@mui/material'
import React from 'react'
import { BackdropPropTypes } from './Backdrop.types'

export const BackdropComponent: React.FC<BackdropPropTypes> = ({
  open,
  onClick,
  color = 'secondary'
}) => {
  return (
    <Backdrop data-testid='backdropComponent' open={open} onClick={onClick}>
      <CircularProgress color={color} />
    </Backdrop>
  )
}

export * from './Backdrop.types'
